import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import Dashboard from "@/views/module/dashboard/dashboard.vue";
import holidaySetup from "@/views/module/attendance/settingsManagement/holidaySetup.vue";
import weekendSetup from "@/views/module/attendance/settingsManagement/weekendSetup.vue";
import shiftSetup from "@/views/module/attendance/settingsManagement/shiftSetup.vue";
import employeeShiftMapping from "@/views/module/attendance/settingsManagement/employeeShiftMapping.vue";
import employeeWeekendSetup from "@/views/module/attendance/settingsManagement/employeeWeekendSetup.vue";
import addManualAttendance from "@/views/module/attendance/manualEntry/addManualAttendance.vue";
import attendanceSummaryReport from "@/views/module/attendance/reports/attendanceSummaryReport.vue";
import employeeDailyAttendanceSheet from "@/views/module/attendance/reports/employeeDailyAttendanceSheet.vue";
import overtimeReport from "@/views/module/attendance/reports/overtimeReport.vue";
import lateEarlyReport from "@/views/module/attendance/reports/lateEarlyReport.vue";
import absentReport from "@/views/module/attendance/reports/absentReport.vue";

export default [
    {
    path: "/attendance",    
    name: "attendance",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Attendance Management",
    },
    children: [
            {
                path: "dashboard",
                meta: {
                    breadcrumb: ["Dashboard"],
                },
                component: Dashboard,
            },
            {
                path: "shift",
                name: "shift",  
                meta: {
                    breadcrumb: ["Shift Setup"],
                },
                component: shiftSetup,
            },
            {
                path: "employee-shift-mapping",
                name: "employee-shift-mapping",
                meta: {
                    breadcrumb: ["Employee & Shift Mapping"],
                },
                component: employeeShiftMapping,
            },
            {
                path: "weekend",
                name: "weekend",  
                meta: {
                    breadcrumb: ["Weekend Setup"],
                },
                component: weekendSetup,
            },
            {
                path: "employee-wise-weekend",
                name: "employee-weekend",  
                meta: {
                    breadcrumb: ["Employee Weekend Setup"],
                },
                component: employeeWeekendSetup,
            },
            {
                path: "holyday",
                name: "holiday",
                meta: {
                    breadcrumb: ["Add Holiday"],
                },
                component: holidaySetup,    
            },
            {
                path: "manual-entry",
                name: "manual-attendance-entry",
                meta: {
                    breadcrumb: ["Manual Attendance Entry"],
                },
                component: addManualAttendance,    
            },
            {
                path: "daily-attendence-summary-report",
                name: "attendance-summary-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Daily Summary"],
                },
                component: attendanceSummaryReport,
            },
            {
                path: "employee-daily-attendance-sheet",
                name: "employee-daily-attendance-sheet",
                meta: {
                    breadcrumb: ["Attendance Reports", "Employee Daily Sheet"],
                },
                component: employeeDailyAttendanceSheet,
            },
            {
                path: "overtime-report",
                name: "overtime-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Overtime"],
                },
                component: overtimeReport,
            },
            {
                path: "late-early-leave-report",
                name: "late-early-leave-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Late & Early Leave"],
                },
                component: lateEarlyReport,
            },
            {
                path: "absent-report",
                name: "absent-report",
                meta: {
                    breadcrumb: ["Attendance Reports", "Absent"],
                },
                component: absentReport,
            }
        ],
    },
];
